<template>
  <div v-show="title === selectedTitle" :data-testId="`${title}_content`">
    <slot />
  </div>
</template>
<script setup lang="ts">
import { inject } from 'vue';
import { Validation } from '@vuelidate/core';

export type TabProps = {
  title: string;
  group?: string;
  validation?: Validation;
};

const props = defineProps<TabProps>();

const selectedTitle = inject('selectedTitle');
</script>
